// Used in the Instance _form.html.erb view, not to do with Users.

document.addEventListener('click', function (event) {
  if (!event.target.matches('.client_name')) return;
  event.preventDefault();

  document.querySelector("#instance_client_name").value = event.target.innerText

}, false);